import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { FormsModule } from '@angular/forms';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { HttpModule } from '@angular/http';
import { FooterComponent } from './footer/footer.component';
import { NavbarComponent } from './navbar/navbar.component';
import { SidebarComponent } from './sidebar/sidebar.component';
import { ToggleFullscreenDirective } from './directives/toggle-fullscreen.directive';
import { UiSwitchModule } from 'ngx-ui-switch';
import { HttpClientModule } from '@angular/common/http';
import { LoadingModule } from 'ngx-loading';
import { TreeModule } from 'ng2-tree';
import { LaddaModule } from 'angular2-ladda';
import { CategoryEditComponent } from 'app/categories/category-edit/category-edit.component';
import { CategoryNewPopupComponent } from 'app/categories/shared/category-new.popup';
import { CategoriesComponent } from 'app/categories/categories.component';
import { CategoryMovePopupComponent } from 'app/categories/shared/category-move.popup';
import { TemplateSavePopupComponent } from 'app/categories/shared/template-save.popup';
import { QuillModule } from 'ngx-quill';
import { InboxComponent } from 'app/messages/messages.component';
import { CategoryNewContentPopupComponent } from 'app/categories/shared/category-new-content.popup';
import { UploadComponent } from 'app/shared/upload/upload.component';
import { UploadButtonComponent } from 'app/shared/upload/upload-button.component';
import { UploadButtonListComponent } from 'app/shared/upload/upload-button-list.component';
import { UploadPopupComponent } from 'app/shared/upload/upload-popup.component';
import { UploadFolderButtonComponent } from 'app/shared/upload/upload-folder-button.component';
import { UploadGridComponent } from 'app/shared/upload/upload-grid.component';
import { ImageComponent } from './upload/image.component';
import { ArchwizardModule } from 'angular-archwizard';
import { FormDesignerComponent } from './form-designer.component';
import { ContentTextPopupComponent } from '../categories/shared/content-text.popup';
import { ContentFormPopupComponent } from 'app/categories/shared/content-form.popup';
import { AngularMultiSelectModule } from 'angular2-multiselect-dropdown/angular2-multiselect-dropdown';
import { DragulaModule } from 'ng2-dragula';
import { CategoryTabOrderPopupComponent } from 'app/categories/shared/category-tab-order.popup';
import { UsersComponent } from 'app/users/users.component';
import { UserEditComponent } from 'app/users/user-edit/user-edit.component';
import { CategoryOrderPopupComponent } from 'app/categories/shared/category-order.popup';
import { GroupOrderPopupComponent } from 'app/settings/groups/shared/group-order.popup';
import { ImageContainerComponent } from './upload/image-container.component';
import { ValidateEqualDirective } from './validate-equal.directive';
import { GalleryContainerComponent } from 'app/shared/upload/gallery-container.component';
import { ImagePreviewPopupComponent } from 'app/shared/upload/image-preview.popup';
import { FormContainerComponent } from 'app/shared/upload/form-container.component';
import { FileContainerComponent } from 'app/shared/upload/file-container.component';
import { FormsComponent } from 'app/forms/forms.component';
import { FormsFilterPipe } from 'app/forms/forms.pipe';
import { MessageEditComponent } from 'app/messages/message-edit/message-edit.component';
import { CategorySelectPopupComponent } from 'app/categories/shared/category-select.popup';
import { ExtraRoleEditPopupComponent } from 'app/users/shared/extra-role-edit.popup';
import { GroupLinkEditPopupComponent } from '../settings/groups/shared/group-link-edit.popup';
import { MessageReceiversPopupComponent } from 'app/messages/shared/message-receivers.popup';
import { DataTableModule } from 'angular2-datatable';
import { UserFilterPipe } from '../users/users.pipe';
import { MatrixUserFilterPipe } from '../settings/group-matrix/group-matrix-users.pipe';
import { DateTimePickerModule } from 'ng-pick-datetime';
import { ChildEditPopupComponent } from 'app/users/shared/child-edit.popup';
import { CategoryPreviewComponent } from 'app/categories/shared/category-preview';
import { TextareaAutosizeModule } from 'ngx-textarea-autosize';
import { NewlinePipe } from './newline.pipe';
import { RichTextPipe } from './rich-text.pipe';
import { NgxDatatableModule } from '@swimlane/ngx-datatable';
import { ColorPickerComponent } from './color-picker.component';
import { PickerModule } from '@ctrl/ngx-emoji-mart';
import { FormReceiversPopupComponent } from 'app/forms/shared/form-receivers.popup';
import { DeactivatedRoleEditPopupComponent } from 'app/settings/groups/shared/group-deactivate-role-edit.popup';
import { BuildingOrderPopupComponent } from 'app/settings/buildings/shared/building-order.popup';
import { BuildingGroupEditPopupComponent } from 'app/settings/buildings/shared/building-group-edit.popup';
import { TranslateModule } from '@ngx-translate/core';
import { CategoryItemComponent } from 'app/categories/shared/category-item.component';
import { SupportComponent } from 'app/support/support.component';
import { MessagesFilterPipe } from 'app/messages/messages.pipe';
import { UploadPermissionsPopupComponent } from './upload/upload-persmissions-popup.component';
import { UploadUsagesPopupComponent } from './upload/upload-usages-popup.component';
import { UploadFolderPopupComponent } from './upload/upload-folder-popup.component';
import { VideoContainerComponent } from './upload/video-container.component';
// import { VgCoreModule } from 'videogular2/core';
import { VimeoContainerComponent } from './upload/vimeo-container.component';
import { VimeoUploadComponent } from './upload/vimeo-upload.component';
import { FileUploadModule } from 'primeng/fileupload';
import { TooltipModule } from 'primeng/tooltip';
import { SafePipe } from './safe.pipe';
import { UnitBuildingEditPopupComponent } from 'app/settings/units/shared/unit-building-edit.popup';
import { UnitOrderPopupComponent } from 'app/settings/units/shared/unit-order.popup';
import { ClassbookComponent } from 'app/classbook/classbook.component';
import { ClassbookEditComponent } from 'app/classbook/classbook-edit/classbook-edit.component';
import { ClassbookDetailComponent } from 'app/classbook/classbook-detail/classbook-detail.component';
import { UsersByGroupComponent } from 'app/users/users-by-group.component';
import { UsersByGroupFilterPipe } from 'app/users/users-by-group.pipe';
import { ClassbookFilterPipe } from 'app/classbook/classbook.pipe';
import { CategoryDeletedPopupComponent } from 'app/categories/shared/category-deleted.popup';
import { WithLoadingPipe } from './with-loading.pipe';
import { ImagePreviewComponent } from './upload/image-preview.component';
import { ClassbookItemComponent } from 'app/personal/shared/classbook-approve-item';
import { CategoryTextComponent } from 'app/categories/shared/category-text.component';
import { ImportFilterPipe } from 'app/settings/imports/imports.pipe';
import { ExtraRoleCreatePopupComponent } from 'app/users/shared/extra-role-create.popup';
import { TimetableEditPopupComponent } from 'app/categories/shared/timetable-edit.popup';
import { MessageSaveTemplatePopupComponent } from 'app/messages/shared/message-save-template.popup';
import { MessageNewPopupComponent } from 'app/messages/shared/message-new.popup';
import { MessageDetailComponent } from 'app/messages/message-detail/message-detail.component';
import { TokensPopupComponent } from 'app/users/shared/tokens.popup';
import { FormDeletedPopupComponent } from 'app/forms/shared/form-deleted.popup';
import { UserDetailComponent } from 'app/users/user-detail/user-detail.component';
import { AdditionalFieldsEditComponent } from 'app/users/shared/additional-fields-edit.component';
import { AdditionalFieldsViewComponent } from 'app/users/shared/additional-fields-view.component';
import { ChildViewPopupComponent } from 'app/users/shared/child-view.popup';
import { CategoryRenderComponent } from 'app/categories/shared/category-render.component';
import { ReplyReceiversPopupComponent } from 'app/messages/shared/reply-receivers.popup';
import { FamilyReplyReceiversPopupComponent } from 'app/messages/shared/family-reply-receivers.popup';
import { MessageAddReceiverPopupComponent } from 'app/messages/shared/message-add-receiver.popup';
import { MessageUsersFilterPipe } from 'app/messages/shared/message-users.pipe';
import { ReplyReceiversInfoPopupComponent } from 'app/messages/shared/reply-receivers-info.popup';
import { FieldOptionsPopupComponent } from 'app/settings/shared/field-options.popup';
import { FieldDescriptionPopupComponent } from 'app/settings/shared/field-description.popup';
import { MessageCategoryComponent } from 'app/messages/message-category/message-category.component';
import { CategoryDetailComponent } from 'app/categories/shared/category-detail.component';
import { ContentTextPromptPopupComponent } from 'app/categories/shared/content-text-prompt.popup';
import { TemplateOrderPopupComponent } from 'app/templates/shared/template-order.popup';
import { MessageSearchPopupComponent } from 'app/messages/shared/message-search.popup';
import { MessageRolesFilterPipe } from 'app/messages/shared/message-roles.pipe';
import { MessageGroupsFilterPipe } from 'app/messages/shared/message-groups.pipe';
import { CategoryPreviewPopupComponent } from 'app/categories/shared/category-preview.popup';
import { AbsencesComponent } from 'app/absences/absences.component';
import { CalendarModule } from 'angular-calendar';
import { DownloadListPopupComponent } from 'app/users/shared/download-list.popup';
import { AbsenceDetailPopupComponent } from 'app/absences/shared/absence-detail.popup';
import { StudentsComponent } from 'app/students/students.component';
import { StudentFilterPipe } from 'app/students/shared/student.pipe';
import { StudentDetailPopupComponent } from 'app/students/shared/student-detail.popup';
import { CategoryImportPopupComponent } from 'app/categories/shared/category-import.popup';
import { StudentsPoschiavoComponent } from 'app/students-poschiavo/students.component';
import { StudentsPoschiavoCheckComponent } from 'app/students-poschiavo-check/students.component';
import { AutoGrowDirective } from './auto-grow.directive';
import { MessageDetailPopupComponent } from 'app/settings/message-delete/shared/message-detail.popup';
import { DownloadListStudentPopupComponent } from 'app/users/shared/download-list-student.popup';

@NgModule({
    imports: [
        RouterModule,
        CommonModule,
        NgbModule,
        FormsModule,
        HttpModule,
        // HttpClientModule,
        UiSwitchModule,
        LoadingModule,
        TreeModule,
        LaddaModule,
        QuillModule,
        ArchwizardModule,
        AngularMultiSelectModule,
        DragulaModule,
        DataTableModule,
        DateTimePickerModule,
        TextareaAutosizeModule,
        NgxDatatableModule,
        PickerModule,
        TranslateModule,
        // VgCoreModule,
        FileUploadModule,
        TooltipModule,
        CalendarModule,
    ],
    declarations: [
        FooterComponent,
        NavbarComponent,
        SidebarComponent,
        ToggleFullscreenDirective,
        CategoriesComponent,
        CategoryEditComponent,
        UsersByGroupComponent,
        CategoryNewPopupComponent,
        AbsenceDetailPopupComponent,
        StudentDetailPopupComponent,
        MessageNewPopupComponent,
        TimetableEditPopupComponent,
        CategoryOrderPopupComponent,
        TemplateOrderPopupComponent,
        MessageSaveTemplatePopupComponent,
        CategoryDeletedPopupComponent,
        FormDeletedPopupComponent,
        FormReceiversPopupComponent,
        GroupOrderPopupComponent,
        BuildingOrderPopupComponent,
        UnitOrderPopupComponent,
        CategoryTabOrderPopupComponent,
        ContentTextPopupComponent,
        ContentTextPromptPopupComponent,
        CategoryPreviewPopupComponent,
        ContentFormPopupComponent,
        CategoryMovePopupComponent,
        CategoryImportPopupComponent,
        CategorySelectPopupComponent,
        CategoryNewContentPopupComponent,
        TemplateSavePopupComponent,
        ClassbookComponent,
        ClassbookEditComponent,
        ClassbookDetailComponent,
        AbsencesComponent,
        StudentsComponent,
        StudentsPoschiavoComponent,
        StudentsPoschiavoCheckComponent,
        AdditionalFieldsEditComponent,
        AdditionalFieldsViewComponent,
        InboxComponent,
        MessageEditComponent,
        MessageCategoryComponent,
        MessageDetailComponent,
        UploadComponent,
        UploadButtonComponent,
        VimeoUploadComponent,
        UploadButtonListComponent,
        UploadFolderButtonComponent,
        UploadPopupComponent,
        UploadPermissionsPopupComponent,
        UploadUsagesPopupComponent,
        UploadFolderPopupComponent,
        UploadGridComponent,
        ImageComponent,
        ImagePreviewComponent,
        ImageContainerComponent,
        FileContainerComponent,
        VideoContainerComponent,
        VimeoContainerComponent,
        GalleryContainerComponent,
        FormContainerComponent,
        FormDesignerComponent,
        UsersComponent,
        UserDetailComponent,
        UserEditComponent,
        ValidateEqualDirective,
        ImagePreviewPopupComponent,
        FormsComponent,
        FormsFilterPipe,
        ClassbookFilterPipe,
        MessagesFilterPipe,
        MessageUsersFilterPipe,
        MessageRolesFilterPipe,
        MessageGroupsFilterPipe,
        ExtraRoleEditPopupComponent,
        ExtraRoleCreatePopupComponent,
        TokensPopupComponent,
        ChildEditPopupComponent,
        ChildViewPopupComponent,
        MessageDetailPopupComponent,
        DownloadListPopupComponent,
        DownloadListStudentPopupComponent,
        GroupLinkEditPopupComponent,
        BuildingGroupEditPopupComponent,
        UnitBuildingEditPopupComponent,
        DeactivatedRoleEditPopupComponent,
        MessageReceiversPopupComponent,
        MessageAddReceiverPopupComponent,
        MessageSearchPopupComponent,
        ReplyReceiversPopupComponent,
        FamilyReplyReceiversPopupComponent,
        ReplyReceiversInfoPopupComponent,
        UserFilterPipe,
        StudentFilterPipe,
        ImportFilterPipe,
        MatrixUserFilterPipe,
        UsersByGroupFilterPipe,
        CategoryPreviewComponent,
        NewlinePipe,
        RichTextPipe,
        SafePipe,
        ColorPickerComponent,
        CategoryItemComponent,
        CategoryDetailComponent,
        CategoryRenderComponent,
        ClassbookItemComponent,
        SupportComponent,
        WithLoadingPipe,
        CategoryTextComponent,
        FieldOptionsPopupComponent,
        FieldDescriptionPopupComponent,
        AutoGrowDirective,
    ],
    exports: [
        CommonModule,
        FooterComponent,
        NavbarComponent,
        SidebarComponent,
        ToggleFullscreenDirective,
        NgbModule,
        FormsModule,
        HttpModule,
        DragulaModule,
        // HttpClientModule,
        UiSwitchModule,
        LoadingModule,
        TreeModule,
        LaddaModule,
        PickerModule,
        TranslateModule,
        // VgCoreModule,
        FileUploadModule,
        TooltipModule,
        CalendarModule,
        CategoriesComponent,
        CategoryEditComponent,
        UsersByGroupComponent,
        CategoryNewPopupComponent,
        AbsenceDetailPopupComponent,
        StudentDetailPopupComponent,
        MessageNewPopupComponent,
        TimetableEditPopupComponent,
        CategoryOrderPopupComponent,
        TemplateOrderPopupComponent,
        MessageSaveTemplatePopupComponent,
        CategoryDeletedPopupComponent,
        FormDeletedPopupComponent,
        FormReceiversPopupComponent,
        CategoryTabOrderPopupComponent,
        GroupOrderPopupComponent,
        CategoryMovePopupComponent,
        CategoryImportPopupComponent,
        CategorySelectPopupComponent,
        CategoryNewContentPopupComponent,
        ContentTextPopupComponent,
        ContentTextPromptPopupComponent,
        CategoryPreviewPopupComponent,
        ContentFormPopupComponent,
        TemplateSavePopupComponent,
        ClassbookComponent,
        ClassbookEditComponent,
        ClassbookDetailComponent,
        AbsencesComponent,
        StudentsComponent,
        StudentsPoschiavoComponent,
        StudentsPoschiavoCheckComponent,
        AdditionalFieldsEditComponent,
        AdditionalFieldsViewComponent,
        InboxComponent,
        MessageEditComponent,
        MessageCategoryComponent,
        MessageDetailComponent,
        QuillModule,
        UploadComponent,
        UploadButtonComponent,
        VimeoUploadComponent,
        UploadButtonListComponent,
        UploadFolderButtonComponent,
        UploadPopupComponent,
        UploadPermissionsPopupComponent,
        UploadUsagesPopupComponent,
        UploadFolderPopupComponent,
        UploadGridComponent,
        ImageComponent,
        ImagePreviewComponent,
        ImageContainerComponent,
        FileContainerComponent,
        VideoContainerComponent,
        VimeoContainerComponent,
        GalleryContainerComponent,
        FormContainerComponent,
        ArchwizardModule,
        FormDesignerComponent,
        AngularMultiSelectModule,
        UsersComponent,
        UserDetailComponent,
        UserEditComponent,
        ValidateEqualDirective,
        ImagePreviewPopupComponent,
        FormsComponent,
        FormsFilterPipe,
        ClassbookFilterPipe,
        MessagesFilterPipe,
        MessageUsersFilterPipe,
        MessageRolesFilterPipe,
        MessageGroupsFilterPipe,
        ExtraRoleEditPopupComponent,
        ExtraRoleCreatePopupComponent,
        TokensPopupComponent,
        ChildEditPopupComponent,
        ChildViewPopupComponent,
        DownloadListPopupComponent,
        DownloadListStudentPopupComponent,
        GroupLinkEditPopupComponent,
        BuildingGroupEditPopupComponent,
        UnitBuildingEditPopupComponent,
        DeactivatedRoleEditPopupComponent,
        MessageReceiversPopupComponent,
        MessageAddReceiverPopupComponent,
        MessageSearchPopupComponent,
        ReplyReceiversPopupComponent,
        FamilyReplyReceiversPopupComponent,
        ReplyReceiversInfoPopupComponent,
        DataTableModule,
        UserFilterPipe,
        ImportFilterPipe,
        MatrixUserFilterPipe,
        UsersByGroupFilterPipe,
        DateTimePickerModule,
        CategoryPreviewComponent,
        TextareaAutosizeModule,
        NewlinePipe,
        RichTextPipe,
        SafePipe,
        NgxDatatableModule,
        ColorPickerComponent,
        CategoryItemComponent,
        CategoryDetailComponent,
        CategoryRenderComponent,
        ClassbookItemComponent,
        SupportComponent,
        WithLoadingPipe,
        CategoryTextComponent,
        FieldOptionsPopupComponent,
        FieldDescriptionPopupComponent,
        AutoGrowDirective,
    ],
})
export class SharedModule { }



// WEBPACK FOOTER //
// ./src/app/shared/shared.module.ts